export default function elementIsVisible(element) {
  return !!(element.offsetWidth || element.offsetHeight);
}



// WEBPACK FOOTER //
// ./utils/element-is-visible.js